<template>
  <div id="itemsWrapper">

    <ul>
      <li v-for="item in items" :key="item.id">
        <article class="message is-link">
          <div class="message-header">
            <p>{{ item.name }} <i class="fas" :class="{ 'fa-chevron-left': !isOpened(item.id), 'fa-chevron-down': isOpened(item.id) }" @click="toggle(item.id)"></i></p>

            <options-buttons
              :pullRight="true"
              :custom="[
                {
                  icon: 'fas fa-user-plus',
                  title: 'Gebruiker koppelen',
                  style: 'has-text-info',
                  click: {
                    fnc: addUser,
                    params: item.id
                  }
                },
                {
                  icon: 'fas fa-table',
                  title: 'Bundel koppelen',
                  style: 'has-text-warning',
                  click: {
                    fnc: addBundle,
                    params: item.id
                  }
                },
                {
                  icon: 'fas fa-plus',
                  title: 'Account toevoegen onder dit niveau',
                  style: 'has-text-grey',
                  click: {
                    fnc: createItemClicked,
                    params: item.id
                  }
                }
              ]"
              @edit="editItemClicked(item.id)"
              @delete="removeItem(item.id)">
            </options-buttons>
          </div>

          <div class="message-body" :class="{ 'is-hidden': !isOpened(item.id) }">
            <div class="box" v-if="item.users.length">
              <h6 class="title is-6">Gebruikers</h6>

              <div class="tags">
                <div v-for="user in item.users" :key="user.id" class="tags has-addons">
                  <span class="tag is-info">
                    {{ user.firstname }} {{ user.lastname }}
                  </span>
                  <a class="is-delete tag" @click="revokeUser(user.id, item.id)"></a>
                </div>
              </div>
            </div>

            <div class="box" v-if="item.bundles.length">
              <h6 class="title is-6">Bundels</h6>

              <div class="tags">
                <div v-for="bundle in item.bundles" :key="bundle.id" class="tags has-addons">
                  <span class="tag is-warning">
                    {{ bundle.name }}
                  </span>
                  <a class="is-delete tag" @click="detachBundle(bundle.id, item.id)"></a>
                </div>
              </div>
            </div>

            <items :items="item.children" :parentId="item.id"></items>
          </div>
        </article>
      </li>
    </ul>
  </div>
</template>

<script>
import { bus } from '@/main'
import OptionsButtons from '@/components/modules/OptionsButtons'

export default {
  name: 'items',
  props: [
    'items',
    'parentId'
  ],
  components: {
    OptionsButtons
  },
  data () {
    return {
      opened: [],
      itemId: null
    }
  },
  methods: {
    toggle (itemId) {
      let position = this.opened.findIndex((x) => {
        return x === itemId
      })

      if (position === -1) {
        this.opened.push(itemId)
      } else {
        this.opened.splice(position, 1)
      }
    },
    isOpened (itemId) {
      return this.opened.includes(itemId)
    },
    createItemClicked (parentId) {
      bus.$emit('createItem', { parentId: parentId })
    },
    editItemClicked (itemId) {
      bus.$emit('editItem', { itemId })
    },
    removeItem (itemId) {
      this.$store.dispatch('items/remove', itemId)
    },
    addUser (itemId) {
      bus.$emit('selectUser', itemId)
    },
    revokeUser (userId, itemId) {
      this.$store.dispatch('items/revoke', {
        itemId: itemId,
        userId: userId
      })
    },
    addBundle (itemId) {
      bus.$emit('selectBundle', itemId)
    },
    detachBundle (bundleId, itemId) {
      this.$store.dispatch('items/exclude', {
        itemId: itemId,
        bundleId: bundleId
      })
    }
  }
}
</script>

<style scoped>
  li {
    margin-bottom: 25px;
  }

  div.tags {
    margin: 3px;
  }

  .message-body .message-body {
    border-right: 0;
  }

  li li {
    margin: 5px 0 5px 5px;
    padding: 5px 0 5px 5px;
  }

  .message-body {
    padding-right: 0;
    border: 1px solid;
  }

  .options {
    position: absolute;
    right: 15px;
  }

  .options span {
    padding: 5px;
    border-radius: 5px;
  }

  .fas {
    margin: 0 5px;
  }

  .box {
    margin-right: 25px;
  }
</style>
